import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { getNFT } from "../../API/functions";

export const useNft = ({ page, perPage, tier, walletAddress, minted }) => {
  const { data, error, isLoading } = useQuery({
    queryKey: ["Nft", { page, perPage, tier, walletAddress, minted }],
    queryFn: () => getNFT({ page, perPage, tier, walletAddress, minted }),
    onSuccess: (result) => {
      toast.success(result.message);
    },
    onError: (error) => {
      toast.error(error.response.data.message);
    },
  });

  return { data, error, isLoading };
};
